import Loading from "./Loading.js"
import NotFound from "./PageNotFound.js";
import Error from "./ErrorPage.js";
import Progress from "./progress.js"
import Footer from "./footer.js"
import Notify from "./Notify.js";
import Funnel from "../services/funnel-service.js";
import Utils from "../services/utils-service.js";

var iconic = IconicJS();

const template = `
<div class="main-section-container" v-cloak>
    <b-loading  />
    <b-progress />
    <main class="main-section" :style="main_section_cs" v-if="!loading.status">
        <b-notify />
        <template v-if="sysInternalError">
            <b-error-page v-if="sysResUid" :iuid="sysResUid"/>
        </template>
        <template v-else-if="pageNotFound">
            <b-page-not-found />
        </template>
        <template v-else>
            <transition name="fade" mode="out-in" @enter="fs.transitionEnter">
                <router-view :key="$route.path" />
            </transition>
        </template>
    </main>
    <b-footer iuid="footer" />
</div>
`;

export default {
    name: 'app-component',
    template,
    components: {
        'b-loading': Loading,
        'b-page-not-found': NotFound,
        'b-error-page': Error,
        'b-progress': Progress,
        'b-footer': Footer,
        'b-notify': Notify
    },
    data() {
        return {
            sysResUid: '',
        }
    },
    created() {
        window.addEventListener("resize", this.onResize);
    },
    destroyed() {
        window.removeEventListener("resize", this.onResize);
    },
    watch: {
        notification: function (newVal, oldVal) {
            if (newVal != oldVal) {
                this.$notify(newVal)
            }

        },
        $route(to, from) {
            this.trackGTM()
        }
    },
    computed: {
        ...Vuex.mapGetters([
            'funnel',
            'custom_template_data',
            'zipcode',
            'window',
            'notification',
            'active_page',
            'loading'
        ]),
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        main_section_cs: function () {
            var ms = document.getElementsByClassName('main-section');
            var body = document.body;
            var w = ms.offsetWidth;
            var h = ms.offsetHeight;
            var bh = body.clientHeight;
            var bw = body.clientWidth;

            return "margin-bottom:" + ((bh - h) / 2) + "px"

        },
        loading: function () {
            return this.$store.getters.loading;
        },
        pageNotFound: function () {
            if(this.loading.status){
                return
            }
            return this.$store.getters.funnel.idsMap.routes.indexOf(this.$route.path) === -1;
        },
        sysInternalError: function () {
            let isError = false;
            const f = this.funnel;
            const sysResp = f.idsMap.system_responses;
            for (const i in sysResp) {
                const elem = f.elements[sysResp[i]];
                if (elem.type == 'error' && elem.b_error) {
                    this.sysResUid = elem.uid;
                    isError = true;
                    if (elem.is_reload) {
                        if (!Utils.isEmpty(elem.back_url)) {
                            this.fs.internalErrorRedirectHandler(this, elem);
                        }
                    }
                    break;
                }
            }
            return isError;
        }
    },
    beforeCreate() {
        const qryParam = this.$router.app.$route.query;

        if (!Utils.isEmpty(qryParam) && !Utils.isEmpty(qryParam.pf)) {
            this.$store.dispatch('prefillFunnel');
        } else {
            this.$store.dispatch('getFunnel');
        }
    },
    mounted() {
    },
    methods: {
        onResize(e) {
            var win = {
                width: window.innerWidth,
                height: window.innerHeight
            }
            this.$store.commit('UPDATE', { prop: 'window', val: win });
        },
        trackGTM() {
            if (this.$gtm !== undefined) {
                this.$gtm.trackView(this.$route.params.page, this.$route.path);
            }
        }
        
    }
};
